module.exports = __webpack_public_path__ + "static/media/get_in_touch.c38421c6.png";